import { NsCaveat } from 'components/common/ns-caveat/NsCaveat';

export const ddCaveatTestId = 'ddCaveatTestId';

const DirectDebitFooter = () => {
  return <NsCaveat heading="Legal information" testId={ddCaveatTestId} />;
};

export default DirectDebitFooter;
